import { jsx as f, Fragment as g } from "react/jsx-runtime";
import { run as v } from "../../utils/run.js";
import "../../utils/sectionPreview.js";
import { useMemo as u } from "react";
import b from "clsx";
import { calculatePlaceholderHeight as $ } from "./utils.js";
import '../../_assets/AspectRatio.CHKlFFvX.css';const x = "_placeholder_1nmch_44", N = "_image_1nmch_61", y = "_fit_cover_1nmch_71", C = "_fit_contain_1nmch_72", M = "_position_center_1nmch_76", T = "_position_top_1nmch_80", j = "_position_left_1nmch_84", A = "_position_right_1nmch_88", F = "_position_bottom_1nmch_92", H = "_fit_none_1nmch_105", P = "_fit_tablet_cover_1nmch_110", q = "_fit_tablet_contain_1nmch_111", z = "_position_tablet_center_1nmch_115", B = "_position_tablet_top_1nmch_119", D = "_position_tablet_left_1nmch_123", E = "_position_tablet_right_1nmch_127", G = "_position_tablet_bottom_1nmch_131", I = "_fit_tablet_none_1nmch_141", J = "_fit_desktop_cover_1nmch_146", K = "_fit_desktop_contain_1nmch_147", L = "_position_desktop_center_1nmch_151", O = "_position_desktop_top_1nmch_155", Q = "_position_desktop_left_1nmch_159", R = "_position_desktop_right_1nmch_163", S = "_position_desktop_bottom_1nmch_167", U = "_fit_desktop_none_1nmch_177", t = {
  placeholder: x,
  image: N,
  fit_cover: y,
  fit_contain: C,
  position_center: M,
  position_top: T,
  position_left: j,
  position_right: A,
  position_bottom: F,
  fit_none: H,
  fit_tablet_cover: P,
  fit_tablet_contain: q,
  position_tablet_center: z,
  position_tablet_top: B,
  position_tablet_left: D,
  position_tablet_right: E,
  position_tablet_bottom: G,
  fit_tablet_none: I,
  fit_desktop_cover: J,
  fit_desktop_contain: K,
  position_desktop_center: L,
  position_desktop_top: O,
  position_desktop_left: Q,
  position_desktop_right: R,
  position_desktop_bottom: S,
  fit_desktop_none: U,
  "slide-in-out": "_slide-in-out_1nmch_1",
  "fade-in-out": "_fade-in-out_1nmch_1"
}, tt = ({
  width: o,
  height: e,
  aspectRatio: s,
  fit: _ = "cover",
  position: n = "center",
  children: i,
  className: h,
  ...d
}) => {
  const c = b(t.placeholder, h), {
    fitMobile: p = _,
    fitTablet: a = _,
    positionMobile: l = n,
    positionTablet: m = n
  } = d, k = v(() => b(
    t.image,
    _ && t[`fit_desktop_${_}`],
    n && t[`position_desktop_${n}`],
    a && t[`fit_tablet_${a}`],
    m && t[`position_tablet_${m}`],
    // Mobile is the default as it doesn't use media queries for best
    // performance.
    p && t[`fit_${p}`],
    l && t[`position_${l}`]
  )), r = u(
    () => ({
      "--aspect-ratio": $({ width: o, height: e, aspectRatio: s }),
      width: o ? `${o}px` : void 0
    }),
    [o, e, s]
  );
  return typeof i == "function" ? /* @__PURE__ */ f(g, { children: i({
    style: r,
    containerClassName: c,
    childClassName: k
  }) }) : /* @__PURE__ */ f("div", { className: c, style: r, children: i });
};
export {
  tt as AspectRatio
};
